import { Device, useDeviceOptimizationStatus, useFeatureFlags, useLocale } from '@e2m-customer-portal/hooks';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface OptimizationStatusProps {
  device: Device;
}

export function OptimizationStatus({
  device,
}: Readonly<OptimizationStatusProps>): ReactElement<OptimizationStatusProps> {
  const [t] = useTranslation();
  const { code: locale } = useLocale();
  const { optimizationStatus, loading } = useDeviceOptimizationStatus(device.id);
  const { isOptimizationStatusEnabled } = useFeatureFlags();

  if (loading || !isOptimizationStatusEnabled) return <></>;

  return (
    <div className="border-grey-300 border-0 border-l border-solid pl-2">
      {optimizationStatus?.isActive ? (
        <div className="h-full grid grid-cols-[repeat(2,_auto)] gap-x-1 text-sm">
          <span className="text-grey-400 text-ellipsis whitespace-nowrap overflow-hidden">
            {t('DEVICE_TABLE_OPTIMIZATION_STATUS')}
          </span>
          <span className="text-success">{t(`OPTIMIZATION_STATUS_${optimizationStatus.interval?.toUpperCase()}`)}</span>
          <span className="text-grey-400 text-ellipsis overflow-hidden">
            {t('DEVICE_TABLE_OPTIMIZATION_NEXT_RUN_DATE')}
          </span>
          <span>
            {optimizationStatus.nextRun?.toLocaleDateString(locale, {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
              hour: 'numeric',
              minute: 'numeric',
            })}
          </span>
        </div>
      ) : (
        <div className="h-full flex flex-col justify-between">
          <span className="col-span-2 text-grey-400 text-xs">{t('DEVICE_TABLE_OPTIMIZATION_STATUS')}</span>
          <span className="col-span-2 text-xl">{t('SHARED_INACTIVE')}</span>
        </div>
      )}
    </div>
  );
}
